import { useEffect, useState } from "react";
export function formatDateRange(beginDateStr, endDateStr) {
    // Преобразуем строки в объекты Date
    const beginDate = new Date(beginDateStr);
    const endDate = new Date(endDateStr);

    // Получаем день, месяц и год для каждой даты
    const beginDay = beginDate.getDate();
    const beginMonth = beginDate.getMonth();
    const beginYear = beginDate.getFullYear();

    const endDay = endDate.getDate();
    const endMonth = endDate.getMonth();
    const endYear = endDate.getFullYear();

    // Массив названий месяцев
    const months = [
        'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
        'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
    ];

    // Если даты в одном месяце и годе
    if (beginMonth === endMonth && beginYear === endYear) {
        return `${beginDay}-${endDay} ${months[beginMonth]}`;
    }
    // Если даты в разных месяцах или годах
    else {
        return `${beginDay} ${months[beginMonth]} - ${endDay} ${months[endMonth]}`;
    }
}

export function useScreenSize() {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);

        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    return { isMobile };
}